// Policies V2 API durations use Go's "Ns" format (e.g. "300s").
const SECONDS_DURATION_PATTERN = /^(\d+)s$/;

export const policyDurationToSeconds = (
  duration: string
): number | undefined => {
  const match = duration.match(SECONDS_DURATION_PATTERN);
  if (!match) {
    return undefined;
  }
  return Number(match[1]);
};

export const secondsToPolicyDuration = (seconds: number): string => {
  return `${seconds}s`;
};
